import { useMeeting } from "@videosdk.live/react-sdk";
import ParticipantStatsPanel from "./ParticipantStatsPanel";
import useRecorderParticipantStats from "../hooks/useRecorderParticipantStats";

/**
 * Owns the recorder's stats poll and renders the panel.
 *
 * Mount exactly ONE of these per page — `useRecorderParticipantStats` runs a 1s
 * `setInterval` against the customer's tracks, so a second instance would double
 * the polling. `RemoteParticipantView` renders one by default; Video Consent
 * opts out (`showStats={false}`) and mounts its own below the Start button,
 * because Figma places the panel there and Start lives in a sibling subtree.
 */
export default function RecorderStatsPanel() {
  const { participants } = useMeeting({});
  const nonLocalParticipantId = Array.from(participants.values()).find(
    (p) => !p.local,
  )?.id;
  const stats = useRecorderParticipantStats(nonLocalParticipantId);

  return <ParticipantStatsPanel stats={stats} />;
}
